import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import AppContext from '@/common/context/app.context'

const CreationDate = ({ parcel }) => {
  const { i18n } = useTranslation()
  const { info } = useContext(AppContext)

  const date = new Intl.DateTimeFormat(i18n.language, {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    timeZone: info?.selectedStore?.timezone,
  }).format(new Date(parcel.created_at))

  const hour = new Intl.DateTimeFormat(i18n.language, {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: info?.selectedStore?.timezone,
  }).format(new Date(parcel.created_at))

  return (
    <Text type="bodyMRegular" customStyles={{ textTransform: 'uppercase', width: '148px' }}>
      {date} · {hour}
    </Text>
  )
}

export default CreationDate
